import styled from 'styled-components'
import Colors from '../../../theme/colors'

export default styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
`

export const Item = styled.div`
  font-family: Montserrat;
  font-weight: 700;
  display: flex;
  flex-direction: row;
  padding-bottom: 10px;

  .count {
    line-height: 24px;
    flex-basis: 42px;
  }

  .title {
    line-height: 24px;
    flex-basis: 400px;
  }

  .price {
    flex-basis: 85px;
    flex-grow: 1;
    justify-self: flex-end;
    text-align: right;
    line-height: 24px;
    font-size: 18px;
    font-weight: 500;
  }

  .description {
    padding: 5px 0 0 0;
    margin: 0;
    font-weight: 200;
  }

  .item {
    list-style: none;
    color: ${Colors.Primary.GreyTextLight};
    line-height: 32px;
  }

  .spinner,
  .delete {
    flex-basis: 23px;
    height: 20px;
    margin: 0 8px;
  }

  .delete {
    display: flex;
    justify-content: center;
    height: 20px;
    margin: 0 8px;

    :hover {
      cursor: pointer;
      background-color: ${Colors.Primary.GreyWhite};
      border-radius: 20px;
      box-shadow: 0 0 0 10px ${Colors.Primary.GreyWhite};
    }
  }
`
